module.exports = __webpack_public_path__ + "img/structure_tile.e4ad5764.jpg";